import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';

/**
 * Static visual mockup of the shop inquiry panel for design review.
 * Intentionally does not submit anywhere: no fetch, no storage, no third-party
 * CAPTCHA script or test key, and no simulated success/verified state.
 */
const INTERESTS = ['Choosing tools', 'Workshops & training', 'Custom fabrication', 'Something else'];
const fieldClass = 'min-h-[44px] min-w-0 w-full border border-steel-200 bg-white px-3 py-2 text-[16px] lg:text-[15px] text-charcoal placeholder:text-steel-400 focus:border-fred';
export function InquiryPanel() {
  return <div className="w-full border border-steel-200 bg-cream p-5 shadow-[0_24px_60px_-32px_rgba(0,0,0,0.9)] lg:max-w-[400px]" data-id="element-221" data-mp="3q2tpxpezyvd5">
      <h2 className="font-display text-[28px] uppercase leading-none text-charcoal" data-id="element-222" data-mp="3uvd5grx8w0kl">Talk to the shop.</h2>
      <p className="mt-2 text-[14px] leading-[1.4] text-steel-600" data-id="element-223" data-mp="2xdwiyig8kkzp">
        Questions about tools, workshops or custom metalwork? Start here.
      </p>

      <form className="mt-4 space-y-2.5" onSubmit={event => event.preventDefault()} data-id="element-224" data-mp="18i0rptcfk64i">
        <div className="grid gap-2.5 lg:grid-cols-2" data-id="element-225" data-mp="13io6fd17j741">
        <div className="min-w-0" data-id="element-226" data-mp="13iwij2pia8e6">
          <label htmlFor="inquiry-name" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-227" data-mp="yroaa9zwwt2l">
            Name
          </label>
          <input id="inquiry-name" name="name" type="text" autoComplete="name" className={fieldClass} data-id="element-228" data-mp="ts1t5pgyqsoi" />
        </div>

        <div className="min-w-0" data-id="element-229" data-mp="powuxz3x1d5o">
          <label htmlFor="inquiry-email" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-230" data-mp="krdin4qs3agd">
            Email
          </label>
          <input id="inquiry-email" name="email" type="email" autoComplete="email" className={fieldClass} data-id="element-231" data-mp="fun2yiivygvh" />
        </div>

        </div>

        <div data-id="element-232" data-mp="2a735b88k9av2">
          <label htmlFor="inquiry-interest" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-233" data-mp="2a5s2pbquq95j">
            I’m interested in
          </label>
          <select id="inquiry-interest" name="interest" defaultValue={INTERESTS[0]} className={fieldClass} data-id="element-234" data-mp="3i2mcn1nnzdz">
            {INTERESTS.map(option => <option key={option} value={option} data-id="element-235" data-mp="8bds0kuqea4b">
                {option}
              </option>)}
          </select>
        </div>

        <div data-id="element-236" data-mp="3uoc8qj23hq8p">
          <label htmlFor="inquiry-message" className="mb-1 block text-[12px] font-medium uppercase tracking-[0.1em] text-steel-600" data-id="element-237" data-mp="3upx58e7yzj97">
            How can we help?
          </label>
          <textarea id="inquiry-message" name="message" rows={2} className={`${fieldClass} block h-[60px] resize-y`} data-id="element-238" data-mp="r8opbzwsyth4" />
        </div>

        {/* Static verification box — visual only, never a real or passed CAPTCHA. */}
        <div aria-hidden="true" className="flex items-center gap-3 border border-steel-200 bg-white px-3 py-2.5" data-id="element-239" data-mp="h8xxy73jgul9">
          <span className="h-5 w-5 shrink-0 border border-steel-400 bg-cream" data-id="element-240" data-mp="2y0zaux44tnck" />
          <span className="text-[14px] text-charcoal" data-id="element-241" data-mp="321j6txcyykx4">I’m not a robot</span>
          <ShieldCheckIcon className="ml-auto h-5 w-5 text-steel-400" data-id="element-242" data-mp="2ufnnjxu3numo" />
        </div>

        <button type="button" aria-disabled="true" className="mt-1 flex min-h-[48px] w-full items-center justify-center bg-fred px-6 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-243" data-mp="2pidsa1k14oqx">
          Send Inquiry
        </button>
      </form>
    </div>;
}